import { useCallback } from 'react';
import { gql } from '@apollo/client';
import { client } from 'lib/apollo/clients';

export const GET_STRIPE_PAYMENT_METHOD = gql`
  query getStripePaymentMethod($stripePaymentMethodId: String!) {
    getStripePaymentMethod(stripePaymentMethodId: $stripePaymentMethodId) {
      name
      email
      lastFour
      address
      cardType
    }
  }
`;

const useGetStripePaymentMethod = () =>
  useCallback(async (stripePaymentMethodId) => {
    try {
      const {
        data: { getStripePaymentMethod },
      } = await client.query({
        query: GET_STRIPE_PAYMENT_METHOD,
        skip: !stripePaymentMethodId,
        variables: { stripePaymentMethodId },
      });

      return getStripePaymentMethod;
    } catch (e) {
      window.newrelic?.noticeError?.(new Error(e));
    }
  }, []);

export default useGetStripePaymentMethod;
